interface Props {
  companyName: string
  primaryColor: string
}

export default function PublicFooter({ companyName, primaryColor }: Props) {
  return (
    <footer className="py-8 px-6 border-t border-black/[0.04] bg-gray-50/50">
      <div className="max-w-6xl mx-auto text-center">
        <p className="text-xs text-gray-400">
          &copy; {new Date().getFullYear()} {companyName}. All rights reserved.
        </p>
        <p className="text-[10px] text-gray-300 mt-1">
          Powered by <span style={{ color: primaryColor }}>PrimeBook AI</span>
        </p>
      </div>
    </footer>
  )
}
